module.exports = __webpack_public_path__ + "assets/img/tx11g_1.18cf6ed9.jpg";